import {
  ApolloClient,
  type ApolloClientOptions,
  InMemoryCache,
  type NormalizedCacheObject,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

interface CreateApolloClientOptions {
  endpoint: string;
  sessionToken: string;
  connectToDevTools?: boolean;
}

const shareApolloSettings = (connectToDevTools: boolean): Partial<ApolloClientOptions<NormalizedCacheObject>> => ({
  connectToDevTools,
  queryDeduplication: true,
});

export const createApolloClient = ({
  endpoint,
  sessionToken,
  connectToDevTools = false,
}: CreateApolloClientOptions) => {
  const httpLink = createHttpLink({ uri: endpoint });
  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      Authorization: sessionToken ? `Bearer ${sessionToken}` : undefined,
    },
  }));

  return new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    ...shareApolloSettings(connectToDevTools),
  });
};
